export default "__VITE_ASSET__YE36YYtZ__"